<template>
  <div v-cloak class="home w-full h-full relative mx-auto" style="width: 100%;">
    <SettingsDialog v-if="showSettings" @close-dialog="showSettings = false" />

    <v-dialog v-model="newWindowOpen" persistent max-width="500px" style="min-height: 700px; max-height: 100%;">
      <v-card>
        <div class="flex items-center flex-column justify-between mb-4 px-4 py-4">
          <div class="text-center" style="color: #333333; margin-bottom: 20px;">
            <h1 class="text-red-700 title" style="font-size: 1.1em">
              The app was opened on another window!
            </h1>
            Do you want to continue here?
          </div>
          <v-btn
              v-on:click="updateReloadAfterNewOpen"
              color="#77ACFF"
              style="color: white;"
          >
            <div class="flex items-center">
              <v-icon :size="24">mdi-refresh</v-icon>
              <span class="mr-1">Update and Reload</span>
            </div>
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="differeceInTime" persistent max-width="500px" style="min-height: 700px; max-height: 100%;">
      <v-card>
        <div class="flex items-center flex-column justify-between mb-4 px-4 py-4">
          <div class="text-center" style="color: #333333; margin-bottom: 20px;">
            <h1 class="text-red-700 title" style="font-size: 1.1em">
              Your computer has wrong time!
            </h1>
            Please, synchronize time in your computer.
          </div>
          <v-btn
              v-on:click="updateReloadAfterNewOpen"
              color="#77ACFF"
              style="color: white;"
          >
            <div class="flex items-center">
              <v-icon :size="24">mdi-refresh</v-icon>
              <span class="mr-1">Reload</span>
            </div>
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <AppointmentDialog v-if="showAppointment" @on-show-settings="onShowSettings" />
    <VirtualKeyboard v-if="showVirtualKeyboard" />
    <AnalyticsDialog v-if="showAnalytics" @close="showAnalytics = false" />
    <NotesDialog v-if="showNotes" :show-notes="showNotes" @close="showNotes = false" />
    <ProfileSettingsDialog v-if="showProfileSettings" @close-profile-settings-dialog="showProfileSettings = false" />
    <div v-if="confirmation.uuid"><ConfirmationDialog /></div>
    <div v-if="viewBoard">
      <div v-if="dashboard && dashboard.rooms"
           class="dashboard-container">
        <WaitingRoom
            v-if="queue && queueUpcoming && queueTomorrow"
            v-bind="{ queue, queueUpcoming, queueTomorrow }"
        />
        <Dashboard />
      </div>
    </div>
    <div id="top-nav">
      <div
          v-if="!isCompactWindow"
          class="d-inline-flex align-center"
      >

        <div class="office-select min-w-[300px] mr-4">
          <v-select
              v-if="offices && offices.length"
              class="locationSelect mt-0 pt-0"
              dense
              hide-details
              :items="offices"
              item-title="name"
              item-value="uuid"
              v-model="office"
              variant="plain"
              density="compact"
              rounded
              @update:model-value="onOfficeSelected"
          >
            <template v-slot:prepend-inner>
              <v-icon small color="#056D97">mdi-map-marker</v-icon>
            </template>
            <template v-slot:selection="{ item }">
              <span class="mb-2">
                {{ item.title.length > 35 ? item.title.substr(0, 34) + '...' : item.title }}
              </span>
            </template>
          </v-select>
        </div>

        <v-speed-dial
            v-model="fab"
            location="top right"
            direction="bottom"
            transition="slide-y-reverse-transition"
            style="display: inline-block;"
        >
          <template v-slot:activator="{ props }">
            <v-btn
                v-bind="props"
                color="blue-darken-2"
                theme="dark"
                icon
                size="x-small"
                class="mr-2"
            >
              <v-icon v-if="fab" :size="24">mdi-close</v-icon>
              <v-icon v-if="!fab" :size="24">mdi-account-multiple</v-icon>
            </v-btn>
          </template>
          <v-btn
              v-if="filtered"
              icon
              size="x-small"
              color="grey-lighten-2"
              @click="resetFilter"
          >
            ALL
          </v-btn>
          <div class="doctorsSpeedDial">
            <v-btn
                v-for="(doctor, i) in doctorsFormatted"
                :key="`doctor-filter-btn-${i}`"
                icon
                :theme="filter === doctor.uuid ? 'dark' : 'light'"
                size="x-small"
                :color="filter === doctor.uuid ? '#48BB78' : 'grey-lighten-2'"
                @click="filterDashboard(doctor)"
            >
              {{ $filters.initials(doctor.name) }}
            </v-btn>
          </div>
        </v-speed-dial>
        <v-btn
            class="mr-2"
            color="teal"
            icon
            size="x-small"
            v-if="viewAnalytics"
            @click="showAnalytics = true"
        >
          <v-icon color="white" :size="18">mdi-chart-bar</v-icon>
        </v-btn>
        <v-btn
            class="mr-2"
            color="#4E8EB1"
            icon
            size="x-small"
            v-if="configureBoard"
            @click="onShowSettings"
        >
          <v-icon color="white" :size="18">mdi-cog</v-icon>
        </v-btn>
        <v-btn
            color="purple"
            class="mr-2"
            icon
            size="x-small"
            @click="showNotes = true"
        >
          <v-icon color="white" :size="18">mdi-bell</v-icon>
        </v-btn>
        <v-btn
            color="red"
            class="mr-2"
            icon
            size="x-small"
            @click="toggleKeyboard()"
        >
          <v-icon color="white" :size="18">mdi-keyboard</v-icon>
        </v-btn>
        <v-btn
            class="mr-2"
            icon
            size="x-small"
            @click="$store.dispatch('TOGGLE_CHECKED_OUT_APPOINTMENTS_MODAL');"
        >
            <v-icon color="blue-darken-2" :size="18">mdi-check</v-icon>
        </v-btn>
        <v-menu
            rounded="lg"
            location="bottom"
            content-class="profile-menu"
        >
          <template v-slot:activator="{ props }">
            <v-btn
                icon
                size="x-small"
                v-bind="props"
                color="#116289"
                class="v-menu-btn"
            >
              <span v-if="!!user" >{{ $filters.initials(user.name) }}</span>
              <v-icon v-if="!user" >mdi-account</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item key="keyOfProfile" v-if="!!user" @click="showProfileSettings = !showProfileSettings">
              <v-list-item-title>
                <v-icon color="black" :size="18">mdi-cog</v-icon> Settings
              </v-list-item-title>
            </v-list-item>
            <v-list-item key="scheduler-link">
              <v-list-item-title>
                <router-link
                    :to="{ path: '/scheduler'}"
                    tag="button"
                    class="mr-4"
                    color="#4E8EB1"
                    fab
                    x-small>
                  <v-icon color="black" :size="18">mdi-calendar-account-outline</v-icon>
                  Scheduler
                </router-link>
              </v-list-item-title>
            </v-list-item>
            <v-list-item key="admin-link" :href="adminPanelUrl" target="_blank">
              <v-list-item-title>
                <v-icon color="black" :size="18">mdi-account-supervisor</v-icon>
                Admin Panel
              </v-list-item-title>
            </v-list-item>
            <v-list-item key="keyOfLogOut" @click="$store.dispatch('authLogout')">
              <v-list-item-title>
                <v-icon color="black" :size="18">mdi-logout</v-icon> Logout
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>

      <div v-if="isCompactWindow" class="mobileElemContainer">
        <v-icon v-if="!compactSpeedDial" @click.stop="compactSpeedDial = !compactSpeedDial">mdi-dots-vertical</v-icon>
        <v-icon v-if="compactSpeedDial" @click.stop="compactSpeedDial = !compactSpeedDial">mdi-close</v-icon>
      </div>
    </div>
    <v-snackbar
      v-model="successState"
      timeout="1500"
    >
      {{ successStateText }}
      <template v-slot:actions>
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="successState = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <v-snackbar
      v-model="errorState"
      color="error"
      timeout="1500"
    >
      {{ errorStateText }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="errorState = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <MobileMenu
        :compact-menu-open="compactSpeedDial"
        @toggle-analytic="showAnalytics = !showAnalytics"
        @on-show-settings="onShowSettings"
        @profile-settings="showProfileSettings = !showProfileSettings"
        @show-notes="showNotes = true"
        @filter-by-doctor="filterDashboard"
        @reset-doctor-filter="resetFilter"
        @compact-speed-deal="compactSpeedDial = !compactSpeedDial"
    />

    <CheckedOutAppointments />
    <CreateAppointmentModal v-if="createAppointmentModal" />
  </div>
</template>

<script lang="ts">
import { boolean } from 'boolean';
import { defineComponent, defineAsyncComponent } from 'vue';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import randomColor from 'randomcolor';
import AppointmentDialog from '@/components/modules/AppointmentDialog.vue';
import ConfirmationDialog from '@/components/modules/ConfirmationDialog.vue';
import Dashboard from '@/components/modules/Dashboard.vue';
import WaitingRoom from '@/components/modules/WaitingRoom.vue';
import { datadogRum } from '@datadog/browser-rum-slim';


export default defineComponent({
  name: 'Home',
  components: {
    AppointmentDialog,
    ConfirmationDialog,
    WaitingRoom,
    Dashboard,
    CreateAppointmentModal: defineAsyncComponent(() => import('@/components/modules/CreateAppointmentModal.vue')),
    CheckedOutAppointments: defineAsyncComponent(() => import('@/components/modules/CheckedOutAppointments.vue')),
    VirtualKeyboard: defineAsyncComponent(() => import('@/components/modules/VirtualKeyboard.vue')),
    AnalyticsDialog: defineAsyncComponent(() => import('@/components/modules/AnalyticsDialog.vue')),
    NotesDialog: defineAsyncComponent(() => import('@/components/modules/NotesDialog.vue')),
    SettingsDialog: defineAsyncComponent(() => import('@/components/modules/SettingsDialog.vue')),
    ProfileSettingsDialog: defineAsyncComponent(() => import('@/components/modules/ProfileSettingsDialog.vue')),
    MobileMenu: defineAsyncComponent(() => import('@/components/modules/MobileMenu.vue')),
  },
  data() {
    return {
      direction: 'top',
      errorState: false,
      errorStateText: 'Something went wrong. Please try again.',
      fab: false,
      compactSpeedDial: false,
      filter: null,
      filtered: false,
      showAnalytics: false,
      showNotes: false,
      showProfileSettings: false,
      showSettings: false,
      successState: false,
      successStateText: '',
      viewBoard: false,
      viewAnalytics: false,
      configureBoard: false,
    };
  },
  computed: {
    ...mapState({
      // @ts-ignore
      user: (state) => state.auth.user,
      // @ts-ignore
      doctors: (state) => state.doctors,
      // @ts-ignore
      showAppointment: (state) => state.showAppointment,
      // @ts-ignore
      confirmation: (state) => state.confirmation,
      // @ts-ignore
      dashboard: (state) => state.auth.dashboard,
      // @ts-ignore
      office: (state) => state.auth.office,
      // @ts-ignore
      offices: (state) => state.auth.user?.offices,
      // @ts-ignore
      showVirtualKeyboard: (state) => state.showVirtualKeyboard,
      // @ts-ignore
      newWindowOpen: (state) => state.newWindowOpen,
      // @ts-ignore
      differeceInTime: (state) => state.auth.differenceInTime,
    }),
    ...mapGetters(['queue', 'queueUpcoming', 'queueTomorrow', 'createAppointmentModal']),
    doctorsFormatted() {
      if (!this.doctors) { return []; }
      return this.doctors
        .filter(({ is_enabled: x }) => boolean(x))
        .map((d) => {
          const name = d.name;
          const initials = name.split(' ').map((n) => n[0]).join('');
          return {
            ...d,
            initials: d.name.split(' ').map((n) => n[0]).join(''),
          };
        });
    },
    selectedOfficeName() {
      const title = this.offices.filter( (eachOffice) => eachOffice.uuid === this.office )[0].name;

      return (title.length > 35) ? title.substr(0, 35 - 1) + '...' : title;
    },
    isCompactWindow() {
      return window.innerWidth <= 1162;
    },
    adminPanelUrl() {
      const isProd = window.location.hostname === 'prestige.foam.dev';
      return isProd
        ? 'https://api-prestige.foam.dev/a/'
        : 'https://dev-api-prestige.foam.dev/a/';
    },
  },
  async created() {
    datadogRum.startView({
      name: 'Home',
      service: 'Dashboard',
      version: '1.0.0',
    });

    // Attach event listeners
    this.$eventBus.on('emit-success', this.setSuccessState);
    this.$eventBus.on('emit-error', this.setErrorState);

    await this.loadInitialData();

    if (window.name === '') {
      await this.REGISTER_OPEN_NEW_WINDOW();
    }

    // Refresh store data when other clients make changes
    if (this.office) {
      this.SUBSCRIBE_TO_CLIENT_RELOAD({uuid: this.office});
    }
  },
  watch: {
    user: 'loadInitialData',
    office(uuid) {
      if (uuid) {
        this.UNSUBSCRIBE_ALL();
        this.SUBSCRIBE_TO_CLIENT_RELOAD({ uuid });
      }
    },
  },
  beforeUnmount() {
    // Detach event listeners
    this.$eventBus.off('emit-success', this.setSuccessState);
    this.$eventBus.off('emit-error', this.setErrorState);

    // Detach queue refresh
    clearInterval(this.queueRefreshInterval);
    this.queueRefreshInterval = null;

    // Detach event listeners
    this.UNSUBSCRIBE_ALL();
  },
  methods: {
    ...mapActions([
      'CLEAR_HISTORY',
      'LOAD_APPOINTMENTS',
      'LOAD_DASHBOARD',
      'LOAD_DOCTORS',
      'LOAD_ROOMS',
      'LOAD_TREATMENTS',
      'SUBSCRIBE_TO_CLIENT_RELOAD',
      'UNSUBSCRIBE_ALL',
      'REGISTER_OPEN_NEW_WINDOW',
    ]),
    ...mapMutations(['setFilter']),
    async loadInitialData() {
      // Populate queue, Rooms, Doctors, and Treatments
      if (!!this.user) {
        const loads = [
          this.LOAD_APPOINTMENTS(),
          this.LOAD_DOCTORS(),
          this.LOAD_TREATMENTS(),
        ];
        if (!this.$store.state.auth.dashboard) {
          loads.push(this.LOAD_DASHBOARD());
        }
        // Not awaited: only the room drag warning needs it, the board should not wait.
        this.LOAD_ROOMS();
        await Promise.all(loads);

        this.viewBoard = await this.$store.dispatch('ableUserTo', 'view board');
        this.viewAnalytics = await this.$store.dispatch('ableUserTo', 'view avanalytics');
        this.configureBoard = await this.$store.dispatch('ableUserTo', 'configure board');
      }
    },
    updateReloadAfterNewOpen() {
      window.name = '';
      window.onbeforeunload = null;
      document.location.reload();
    },
    filterDashboard(doctor) {
      this.filter = doctor.uuid;
      this.filtered = true;
      this.setFilter({ filter: doctor.uuid });
    },
    initials(value: string): string {
      if (!value) { return ''; }
      return value.split(' ').map((n: string) => n[0]).join('');
    },
    async onOfficeSelected(uuid: string) {
      this.CLEAR_HISTORY();
      this.UNSUBSCRIBE_ALL();
      this.$store.commit('setOffice', { data: uuid });
      await Promise.all([
        this.LOAD_APPOINTMENTS(),
        this.LOAD_DASHBOARD(),
        this.LOAD_DOCTORS(),
        this.LOAD_ROOMS(),
        this.LOAD_TREATMENTS(),
        this.SUBSCRIBE_TO_CLIENT_RELOAD({uuid}),
      ]);
    },
    onShowSettings() { this.showSettings = true; },
    randomColor() { return randomColor(); },
    resetFilter() {
      this.filter = null;
      this.filtered = false;
      this.setFilter({ filter: '' });
    },
    setErrorState({ state, text }) {
      this.errorState = state;
      if (text || text === '') { this.errorStateText = text; } else { this.errorStateText = 'Something went wrong. Please try again.'; }
    },
    setSuccessState({ state, text }) {
      this.successState = state;
      this.successStateText = text;
    },
    toggleKeyboard() {
      this.$store.dispatch('toggleKeyboard');
    },
  },
});
</script>

<style scoped>
[v-cloak] {
  display: none;
}

.home {
  max-height: 100%;
}

.v-menu-btn {
  color: white;
  font-size: 1.1em
}

#top-nav {
  top: -40px;
  right: 16px;
  z-index: 1025;
  @apply absolute flex items-center;
  width: max-content;
  display: flex;
  justify-content: flex-end;
}

.office-select {
  display: inline-block;
}

.office-select :deep(.v-input__slot::before), .office-select :deep(.v-input__slot::after) {
  border-style: none !important;
  content: unset !important;
}

.locationSelect .v-input__slot:before {
  border-style: none !important;
  display: inline-block;
}
.locationSelect .v-input__slot:after {
  border-style: none !important;
}

#bottom-nav {
  right: 16px;
  bottom: 4px;
  z-index: 100;
  @apply absolute flex items-center;
}

.v-speed-dial {
  top: 0 !important;
}

.v-speed-dial__list {
  padding-top: 8px !important;
}

.dashboard-container {
  position: absolute;
  top: 0;
  left: 0;
  overflow-y: scroll;
  width: 100%;
  height: 100%;

  scroll-padding-bottom: 40px;
}

.dashboard-container::-webkit-scrollbar {
  display: block;
  width: 7px;
  height: 7px;
  background-color: #eaeaea;
  border-radius: 7px;
  margin: 0 10px;
}

.dashboard-container::-webkit-scrollbar-track {
  border-radius: 8px;
  background-color: #e7e7e7;
  border: 1px solid #cacaca;
}

.dashboard-container::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background-color: #4e61b1;
}

.doctorsSpeedDial {
  display: flex;
  flex-direction: column;
  gap: 3px;
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
}

.doctorsSpeedDial::-webkit-scrollbar {
  display: block;
  width: 5px;
  height: 5px;
  background-color: #eaeaea;
  border-radius: 5px;
}

.doctorsSpeedDial::-webkit-scrollbar-thumb {
  display: block;
  width: 5px;
  height: 5px;
  background-color: #4e61b1;
  border-radius: 5px;
  cursor: pointer;
}

.profile-menu {
  margin-top: 40px;
  contain: initial;
  overflow: visible;
}
.profile-menu::before {
  position: absolute;
  content: "";
  top: 0;
  right: 10px;
  transform: translateY(-100%);
  width: 10px;
  height: 13px;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 13px solid #fff;
}
.profile-menu .v-list {
  border-radius: 10px;
}
.mobileElemContainer {
  padding: 5px 0;
}
</style>
